import { ReactElement, useState } from 'react';
import { Component as CaretDownIcon } from 'icons/icon-ui--caret-outline.svg';
import { Component as CaretUpIcon } from 'icons/icon-ui--caret-up-outline.svg';
import styles from './ProductDisplayPage.module.scss';

type Ingredient = {
  name: string;
};

type Props = {
  ingredients: Ingredient[];
  productType: string;
  defaultOpen?: boolean;
};

export function Ingredients({
  ingredients,
  productType,
  defaultOpen = true,
}: Props): ReactElement {
  const [showIngredients, setShowIngredients] = useState(defaultOpen);
  const toggleShowIngredients = () => setShowIngredients((prev) => !prev);

  return (
    <div className={styles.accordion_container}>
      <div
        role="button"
        tabIndex={0}
        onClick={toggleShowIngredients}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleShowIngredients();
          }
        }}
      >
        <div className={styles.dropdown}>
          <h3 className={styles.accordion_title}>Ingredients</h3>
          {showIngredients ? <CaretUpIcon width={23} /> : <CaretDownIcon width={23} />}
        </div>
      </div>
      <hr className={styles.accordion_divider} />
      {showIngredients && productType === 'Meal Kit' && (
        <ul className={styles.ingredients_container}>
          {ingredients.map(({ name }) => (
            <li key={name} className={styles.ingredient}>{name}</li>
          ))}
        </ul>
      )}
      {showIngredients && productType !== 'Meal Kit' && (
        <p>
          {ingredients.map((ingredient) => ingredient.name)
            .join(', ')}
        </p>
      )}
    </div>
  );
}
